import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import * as React from 'react';

const VEPForm = ({ formData }: IOwnProps): React.JSX.Element => (
  <FormRow title="general.date">
    <InputHandler
      type="PartialDate"
      editing={true}
      name="date"
      formData={formData}
      dateDefault="now"
      isNotCancellable={true}
    />
  </FormRow>
);

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'vep'>>;
}

export default VEPForm;
